import { createAsyncThunk, createEntityAdapter, createSlice, EntityState } from "@reduxjs/toolkit";
import { Project, ProjectHeader } from "../projectSlice";
import { AppId, AppThunkAPIType } from "../../../app/appTypes";
import { getWithAuth } from "../../../http";


export const loadArchivedProjects = createAsyncThunk<ProjectHeader[], void, AppThunkAPIType>(
    "projects/archived/load", async (_, { dispatch, rejectWithValue }) => {
        const result = await dispatch(getWithAuth({ url: `api/archived-projects` }))
        const { payload } = result

        if (getWithAuth.fulfilled.match(result)) {
            return payload as ProjectHeader[]
        } else {
            return rejectWithValue(payload ?? { kind: 'unknown' })
        }
    })

export const loadArchivedProject = createAsyncThunk<Project, AppId, AppThunkAPIType>(
    "projects/archived/loadOne", async (id: AppId, { dispatch, rejectWithValue }) => {
        const result = await dispatch(getWithAuth({ url: `api/archived-projects/${id}` }))
        const { payload } = result
        if (getWithAuth.fulfilled.match(result)) {
            return payload as Project
        } else {
            return rejectWithValue(payload ?? { kind: 'unknown' })
        }
    })




// export const unArchiveProject = createAsyncThunk<AppId, ProjectActionArgs, AppThunkAPIType>(
//     "projects/archived/unarchive",
//     async ({ id, args }, { dispatch, rejectWithValue }) => {
//         const result = await dispatch(putWithAuth({
//             url: `api/project/${id}/archive`,
//             payload: args ?? {},
//         }))
//         const { payload } = result
//         if (putWithAuth.fulfilled.match(result)) {
//             return id
//         } else {
//             return rejectWithValue(payload ?? { kind: 'unknown' })
//         }
//     }
// )

